// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2FE4j","modalForm":"UpgradeEpcsModal_modalForm__2pAxM","modalFooter":"UpgradeEpcsModal_modalFooter__pwekn"};